var DEFAULT_BATCH_SIZE = 20;
var DEFAULT_TIMER = 5000;
var STORE_KEY = '@mixpanel/queue';
export default function QueueWithTimer(_a) {
    var batchSize = _a.batchSize, fireTime = _a.fireTime, callback = _a.callback;
    var stopTimer = true;
    var store = window.localStorage;
    batchSize = batchSize || DEFAULT_BATCH_SIZE;
    fireTime = fireTime || DEFAULT_TIMER;
    if (!callback)
        return new Error('callback is mandatory for batching');
    function executeFromQueue() {
        var allEvents = JSON.parse(store.getItem(STORE_KEY));
        if (callback && allEvents && allEvents.length) {
            var batch = allEvents.splice(0, batchSize);
            store.setItem(STORE_KEY, JSON.stringify(allEvents));
            callback(batch);
        }
        !stopTimer && setTimeout(executeFromQueue, fireTime);
    }
    return {
        add: function (event) {
            var oldEvents = JSON.parse(store.getItem(STORE_KEY)) || [];
            oldEvents.push(event);
            var queue = JSON.stringify(oldEvents);
            store.setItem(STORE_KEY, queue);
        },
        stop: function () { return (stopTimer = true); },
        start: function () {
            if (stopTimer) {
                stopTimer = false;
                setTimeout(executeFromQueue, fireTime);
            }
        },
    };
}
//# sourceMappingURL=QueueWithTimer.js.map